import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ICONS from "../../../../../assets/Icons";
import AssociateAccountBankEdit from "../../../../../containers/Accounts/BeneficiaryEditAccount/AssociateAccountBankEdit";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import BankDetails from "../../../../_utils/AccountCreationComponents/BankDetails";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import CommonLayout from "../../../../_utils/CommonLayout";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import BeneAccountDetailsPopup from "../../BeneAccountDetailsPopup";
import "./index.css";

const BeneAccountStepBank = ({
  setBankLookupNext,
  bankLookupNext,
  setIsNextButtonEnabled,
  payload,
  setPayload,
  activeStep,
  setBankIsArchived,
  setBankIsApproved,
  setBankIsDennied,
  setBankIsPending,
  setBankDisableCreateNext,
  setBankAccountType,
  active,
  setActive,
  setBankNewMessage,
  hideBankBlock,
  setBankHideBlock,
  setBankHideCreate,
  isButtonDisabled,
  setBankUserInfo,
  bankVerificationStatus,
  setBankVerificationStatus,
  isIFSCValid,
  isBankError,
  virtualAccount,
  setVirtualAccount,
  previousId,
  verifiedPan,
  setPreviousBankNo,
  isBankLinkedAccount,
  setIsBankLinkedAccount,
  setManualVirtualAccount,
  manualVirtualAccount,
  ownerAccIfscData,
  ownerAccIfscError,
  ifscData,
}) => {
  const [activeTab, setActiveTab] = useState("Active");
  const [showAccInfo, setShowAccInfo] = useState(false);
  const [isApprovedState, setIsApprovedState] = useState([]);
  const [isCreateAccount, setIsCreateAccount] = useState(false);
  const [slideDirection, setSlideDirection] = useState("right");
  const [beneDetails, setBeneDetails] = useState(false);
  const [beneAccountId, setBeneAccountId] = useState("");

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );
  const beneLookLoading = useSelector(
    (state) => state.beneAllVerification.beneLookLoading,
  );
  const { ownerAccIfscLoading } = useSelector(
    (state) => state.ownerAllVerification,
  );

  let haveAcheived = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "archived";
  });
  let haveApproved = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveDennied = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "denied";
  });
  let havePending = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBlock = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "blocked";
  });
  let haveRejected = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "rejected";
  });

  const accounts = benebankLookData?.beneficiary_accounts || [];

  const addSpacesToNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const ActiveData = () => {
    setActive(false);
    setBankIsDennied(false);
    setBankIsApproved(false);
    setBankIsArchived(false);
    if (activeTab === "Inactive") setSlideDirection("left");
    setActiveTab("Active");
    setBankIsPending(false);
    setBankAccountType({
      type: "",
      id: "",
    });
    setBankHideBlock(false);
    setShowAccInfo(false);
  };

  const DeactiveData = () => {
    setActive(true);
    setBankIsDennied(false);
    setBankIsApproved(false);
    setBankIsArchived(false);
    setBankIsPending(false);
    if (activeTab === "Active") setSlideDirection("right");
    setActiveTab("Inactive");
    setShowAccInfo(false);
    setBankAccountType({
      type: "",
      id: "",
    });
  };

  const details =
    !beneLookLoading &&
    (benebankLookData?.beneficiary_accounts?.length ===
      GlobalConfiguration.lengthCheckZero ||
      benebankLookData === null) &&
    !isBankError &&
    isIFSCValid &&
    !virtualAccount;

  const shouldDisableConfirm = isBankLinkedAccount && isIFSCValid;

  const isIconGrey = shouldDisableConfirm || !bankLookupNext;

  useEffect(() => {
    let haveApprovedLinked = benebankLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id === previousId;
      },
    );

    let haveApprovedNotLinked = benebankLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id !== previousId;
      },
    );

    if (haveApprovedLinked && haveApprovedNotLinked) {
      const newData = [...haveApprovedLinked, ...haveApprovedNotLinked];
      setIsApprovedState(newData);
    }
  }, [benebankLookData]);

  useEffect(() => {
    benebankLookData?.beneficiary_accounts?.find((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [benebankLookData]);

  useEffect(() => {
    const foundAccount = benebankLookData?.beneficiary_accounts?.find((val) => {
      if (
        payload?.panNumber === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.ifsc_code === val?.ifsc_code
      ) {
        setIsBankLinkedAccount(true);
        setIsCreateAccount(true);

        return true;
      }
      return false;
    });

    if (!foundAccount) {
      setIsBankLinkedAccount(false);
      setIsCreateAccount(false);
    }
  }, [benebankLookData, payload]);

  return (
    <>
      {beneDetails && (
        <>
          <BeneAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setBeneDetails(false);
            }}
            bene_account_id={beneAccountId}
            type={"bene_account_detail_modal"}
          />
        </>
      )}
      <div className="flex flex-col Qsmd:flex-row px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base Qsmd:gap-gap-xl max-w-tab-width-normal w-full mx-auto gap-gap-md">
        <CommonLayout>
          <div className="w-width-full">
            {hideBankBlock && !isBankError && !virtualAccount ? (
              <div className="bene_block_message_text">
                <img
                  src={
                    "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  }
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            ) : isBankLinkedAccount && isIFSCValid ? (
              <div className="bank_new_message_text_block_nonarchive">
                <img
                  src="https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>
                  Looks like this bank account is already linked to your PAN.
                  Please update either the bank details or your PAN to proceed.
                </p>
              </div>
            ) : null}
            {virtualAccount && isIFSCValid ? (
              <div className="bene_new_message_text_crt">
                <img
                  src={ICONS?.VIRTUAL_ACCOUNT}
                  alt="Virtual Account"
                  className="h-icon-md mr-margin-md"
                />
                <p>
                  <span>Virtual Account Detected</span> <br />
                  <ul className="list-disc px-padding-button-m py-padding-button-m">
                    <li>
                      Account could not be verified as it is virtual account
                    </li>
                    <li className="pt-padding-sm">
                      self verify and proceed with caution
                    </li>
                  </ul>
                </p>
              </div>
            ) : null}
            <div className="w-width-full h-fit lg:max-w-[var(--create-box-width)] Qsmd:!pb-padding-md">
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={setIsNextButtonEnabled}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                setBankUserInfo={setBankUserInfo}
                setShowAccInfo={setShowAccInfo}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
                manualVirtualAccount={manualVirtualAccount}
                setManualVirtualAccount={setManualVirtualAccount}
                ifscData={ifscData}
                ownerAccIfscError={ownerAccIfscError}
                ownerAccIfscLoading={ownerAccIfscLoading}
              />
            </div>
          </div>

          <div
            className={`w-width-full flex flex-col lg:max-w-[var(--create-box-width)] pb-padding-md`}
          >
            {isBankError === true &&
              ownerAccIfscError === false &&
              !ownerAccIfscLoading && (
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={globalText?.MARK_VIRTUAL_ACCOUNT}
                  note={globalText?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={manualVirtualAccount}
                  onToggle={() => {
                    const nextState = !manualVirtualAccount;
                    setManualVirtualAccount(nextState);
                    setBankVerificationStatus(!bankVerificationStatus);
                    setPayload({
                      ...payload,
                      virtual: nextState ? true : false,
                    });
                  }}
                />
              )}

            <ConfirmBtnAccCreation
              type="bank"
              status={
                benebankLookData?.beneficiary_accounts?.length >
                GlobalConfiguration.lengthCheckZero
              }
              isIFSCValid={isIFSCValid}
              isBankError={isBankError}
              lookupNext={!shouldDisableConfirm && bankLookupNext}
              isButtonDisabled={shouldDisableConfirm}
              nextButtonEnabled={isIconGrey}
              handleClick={() => {
                if (shouldDisableConfirm) return;
                if (!isButtonDisabled && !isCreateAccount) {
                  setIsCreateAccount(false);
                  setBankIsApproved(false);
                  setBankLookupNext(true);
                  setBankIsArchived(false);
                  setBankIsDennied(false);
                  setBankIsPending(false);
                  setBankHideBlock(false);
                  setBankDisableCreateNext(false);
                  if (bankLookupNext) {
                    setIsNextButtonEnabled(true);
                  } else {
                    setIsNextButtonEnabled(false);
                  }
                  if (bankLookupNext) {
                    setBankNewMessage(true);
                    setBankHideCreate(false);
                    setBankLookupNext(false);
                  } else {
                    setBankHideCreate(true);
                    setBankNewMessage(false);
                  }
                  setBankAccountType({ type: "", id: "" });
                  setBankDisableCreateNext(true);
                }
              }}
            />

            <div
              style={{
                display:
                  (benebankLookData === null ||
                    benebankLookData?.beneficiary_accounts?.length ===
                      GlobalConfiguration.lengthCheckZero) &&
                  virtualAccount
                    ? "none"
                    : (benebankLookData === null ||
                          benebankLookData?.beneficiary_accounts?.length >=
                            GlobalConfiguration.lengthCheckZero) &&
                        isIFSCValid &&
                        !isBankError
                      ? "block"
                      : "none",
              }}
            >
              <AssociateAccountBankEdit
                ActiveData={ActiveData}
                DeactiveData={DeactiveData}
                haveAcheived={haveAcheived}
                haveDennied={haveDennied}
                haveBlock={haveBlock}
                haveRejected={haveRejected}
                isApprovedState={isApprovedState}
                haveApproved={haveApproved}
                havePending={havePending}
                isActive={active}
                activeTab={activeTab}
                setSlideDirection={setSlideDirection}
                slideDirection={slideDirection}
                setActiveTab={setActiveTab}
                previousId={previousId}
                addSpacesToNumber={addSpacesToNumber}
                beneLookLoading={beneLookLoading}
                verifiedPan={verifiedPan}
                details={details}
                setAccountId={setBeneAccountId}
                setAccoutDetails={setBeneDetails}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};
export default BeneAccountStepBank;
